import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar-dropdown"
export default class extends Controller {
  static targets = ["trigger", "menu", "icon"]

  connect() {
    // Load saved dropdown states from sessionStorage
    const savedStates = this.getSavedStates()
    
    // Initialize all menus based on saved state, default-open attribute, or default to hidden
    this.menuTargets.forEach(menu => {
      const menuId = menu.dataset.menuId
      const defaultOpen = menu.dataset.defaultOpen === "true"
      const isOpen = savedStates[menuId] === true || (savedStates[menuId] === undefined && defaultOpen)
      
      if (isOpen) {
        menu.classList.remove('hidden')
        menu.classList.add('block')
        // Also rotate the corresponding icon
        const icon = this.iconTargets.find(i => i.dataset.menuId === menuId)
        if (icon) {
          icon.classList.add('rotate-180')
        }
      } else {
        menu.classList.add('hidden')
        menu.classList.remove('block')
      }
    })
  }

  toggle(event) {
    event.preventDefault()
    
    const trigger = event.currentTarget
    const menuId = trigger.dataset.menuId
    
    // Find the corresponding menu and icon
    const menu = this.menuTargets.find(m => m.dataset.menuId === menuId)
    const icon = this.iconTargets.find(i => i.dataset.menuId === menuId)
    
    if (menu && icon) {
      // Toggle the menu visibility
      const isHidden = menu.classList.contains('hidden')
      
      if (isHidden) {
        menu.classList.remove('hidden')
        menu.classList.add('block')
        icon.classList.add('rotate-180')
        this.saveState(menuId, true)
      } else {
        menu.classList.remove('block')
        menu.classList.add('hidden')
        icon.classList.remove('rotate-180')
        this.saveState(menuId, false)
      }
    }
  }

  getSavedStates() {
    try {
      const saved = sessionStorage.getItem('sidebarDropdownStates')
      return saved ? JSON.parse(saved) : {}
    } catch (e) {
      return {}
    }
  }

  saveState(menuId, isOpen) {
    try {
      const states = this.getSavedStates()
      states[menuId] = isOpen
      sessionStorage.setItem('sidebarDropdownStates', JSON.stringify(states))
    } catch (e) {
      // Silently fail if sessionStorage is not available
    }
  }
}
